import { Component, ViewChild, NgZone, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { SecurityService } from '../services/security.service';
import { StorageService } from '../services/storage.service';

@Component({
	selector: 'app-change-color',
	templateUrl: './change-color.component.html',
	styleUrls: ['./change-color.component.scss']
})
export class ChangeColorComponent {

	@ViewChild('modalRef') modalRef: ModalDirective;
	@ViewChild('picker') pickerRef: ElementRef;

	selectedColor = '#FFFFFF';
	message = '';
	error = '';

	constructor(
		private securityService: SecurityService,
		private storageService: StorageService,
		private zone: NgZone,
		private cdr: ChangeDetectorRef
	) { }

	show() {
		this.message = '';
		this.error = '';
		const lr = this.storageService.getLoginResponse();
		this.selectedColor = (lr && lr.color) || '#FFFFFF';
		this.modalRef.show();

		// Set initial value and attach native listeners after modal is shown
		setTimeout(() => {
			if (this.pickerRef) {
				this.pickerRef.nativeElement.value = this.selectedColor;
			}
			this.attachPickerListeners();
		}, 100);
	}

	private attachPickerListeners() {
		if (!this.pickerRef) return;
		const el = this.pickerRef.nativeElement as HTMLInputElement;

		el.addEventListener('input', (e: any) => {
			this.zone.run(() => {
				this.selectedColor = e.target.value;
				this.cdr.detectChanges();
			});
		});

		el.addEventListener('change', (e: any) => {
			this.zone.run(() => {
				this.selectedColor = e.target.value;
				this.cdr.detectChanges();
			});
		});
	}

	save() {
		this.message = '';
		this.error = '';
		this.securityService.changeOwnColor(this.selectedColor).subscribe(
			() => {
				const lr = this.storageService.getLoginResponse();
				lr.color = this.selectedColor;
				this.storageService.setLoginResponse(lr);
				this.modalRef.hide();
				window.location.reload();
			},
			(err) => {
				this.error = (err.error && err.error.message) || 'Грешка при смяна на цвят';
			}
		);
	}

	cancel() {
		this.modalRef.hide();
	}
}
